import type { DocType } from '@/types/company';

// Итоговые (подписанные обеими сторонами) документы: их docType — канонический признак «подписан»
// (docSignStatus у них приходит IsNotUsed, полагаться на него нельзя). Держим единый набор здесь,
// чтобы карточка (бейдж завершения) и хук подсветки «только что подписан» не разъезжались.
// Связано: DocumentGroupCard.SIGNED_RESULT_BADGE, useJustSignedDocTypes.
export const SIGNED_RESULT_DOC_TYPES: ReadonlySet<DocType> = new Set<DocType>([
  'SIGNED_VERIFIED_PROFILE',
  'SIGNED_AGENCY_AGREEMENT',
]);
